"use strict";
/** state: Final **/
/** family: Radio **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Button_1 = require("../Button");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var CLASS_NAME = 'i-radio';
var RadioMode;
(function (RadioMode) {
    RadioMode["Button"] = "button";
    RadioMode["Radio"] = "radio";
    RadioMode["Switch"] = "switch";
})(RadioMode = exports.RadioMode || (exports.RadioMode = {}));
var Radio = (function (props) {
    var _a;
    var checked = props.checked, className = props.className, defaultChecked = props.defaultChecked, disabled = props.disabled, icon = props.icon, iconName = props.iconName, isInline = props.isInline, label = props.label, labelHidden = props.labelHidden, mode = props.mode, name = props.name, onChange = props.onChange, value = props.value, restProps = __rest(props, ["checked", "className", "defaultChecked", "disabled", "icon", "iconName", "isInline", "label", "labelHidden", "mode", "name", "onChange", "value"]);
    var radioWrapperClasses = classNames(CLASS_NAME, 'custom-control', 'custom-radio', (_a = {
            'custom-control-inline': isInline
        },
        _a[CLASS_NAME + "--disabled"] = disabled,
        _a), className);
    var innerClasses = classNames(CLASS_NAME + "__label", 'custom-control-label');
    var buttonStyles = classNames('btn', "btn-" + Button_1.ButtonMode.Secondary, 'i-btn', CLASS_NAME + "__label--button", {
        disabled: disabled,
    }, innerClasses);
    var inputClasses = classNames('sr-only', 'custom-control-input', CLASS_NAME + "__input");
    var spanClasses = mode === RadioMode.Radio ? innerClasses : buttonStyles;
    var handleChange = function (e) {
        var updatedProps = __assign({}, props, { checked: !checked });
        onChange(e, updatedProps);
    };
    return (React.createElement("label", __assign({ "aria-disabled": disabled, className: radioWrapperClasses }, restProps),
        React.createElement("input", { checked: checked, className: inputClasses, defaultChecked: defaultChecked, disabled: disabled, name: name, onChange: onChange && handleChange, type: "radio", value: value }),
        React.createElement("span", { "aria-label": labelHidden ? label : null, className: spanClasses },
            icon && React.createElement(IconWrapper_1.IconWrapper, null, icon),
            iconName && (React.createElement(IconWrapper_1.IconWrapper, null,
                React.createElement(FontAwesome_1.FontAwesome, { name: iconName }))),
            !labelHidden && label)));
});
exports.Radio = Radio;
Radio.Mode = RadioMode;
Radio.defaultProps = {
    mode: RadioMode.Radio,
};
//# sourceMappingURL=Radio.js.map